<template>
  <app-logged id="TecnicosCreate">
    <v-flex
      :sm6="!!tecnico.id"
      xs12
    >
      <validation-observer
        ref="observer"
        v-slot="{ invalid }"
        tag="form"
      >
        <v-form>
          <app-widget
            actions
            :class-widget="(!!tecnico.id) ? 'xs12' : 'md6 offset-md3 sm8 offset-sm2 xs12'"
          >
            <div slot="widget-content">
              <validation-provider
                name="usuário"
                rules="required"
                v-slot="{ errors }"
              >
                <v-select
                  :disabled="!!tecnico.id"
                  :items="usuarios"
                  v-model="tecnico.user_id"
                  outlined
                  label="Usuário responsável"
                  :return-object="false"
                  item-text="nome"
                  item-value="id"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <AppFormHeader
                title="Informações de endereço"
                icon="home"
              />
              <validation-provider
                name="endereco"
                rules="required|max:255"
                v-slot="{ errors }"
              >
                <v-text-field
                  v-model="tecnico.endereco"
                  label="Endereço"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <validation-provider
                name="complemento"
                rules="max:300"
                v-slot="{ errors }"
              >
                <v-text-field
                  v-model="tecnico.complemento"
                  label="Complemento"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <validation-provider
                name="cep"
                rules="required|max:9"
                v-slot="{ errors }"
              >
                <v-text-field
                  v-model="tecnico.cep"
                  v-mask="`#####-###`"
                  type="tel"
                  label="CEP"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <validation-provider
                name="cidade"
                rules="required"
                v-slot="{ errors }"
              >
                <v-select
                  :items="cidades"
                  v-model="tecnico.cidade_id"
                  label="Cidade"
                  :return-object="false"
                  :item-text="cidade"
                  item-value="id"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <AppFormHeader
                title="Informações pessoais"
                icon="assignment_ind"
              />
              <validation-provider
                name="número do rg"
                rules="required|max:14"
                v-slot="{ errors }"
              >
                <v-text-field
                  type="tel"
                  v-model="tecnico.rg_numero"
                  label="RG"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <validation-provider
                name="orgão expedidor"
                rules="required|max:14"
                v-slot="{ errors }"
              >
                <v-text-field
                  v-model="tecnico.rg_orgao_expedidor"
                  label="Órgão Expedidor"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <validation-provider
                name="data da expedição"
                rules="required"
                v-slot="{ errors }"
              >
                <v-text-field
                  type="date"
                  v-model="tecnico.rg_data_expedicao"
                  label="Data da expedição"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <validation-provider
                name="número do cpf"
                rules="required|max:14"
                v-slot="{ errors }"
              >
                <v-text-field
                  v-mask="`###.###.###-##`"
                  type="tel"
                  v-model="tecnico.cpf_numero"
                  label="CPF"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <validation-provider
                name="data de nascimento"
                rules="required"
                v-slot="{ errors }"
              >
                <v-text-field
                  type="date"
                  v-model="tecnico.data_nascimento"
                  label="Data de nascimento"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <validation-provider
                name="número do título de eleitor"
                rules="required|max:45"
                v-slot="{ errors }"
              >
                <v-text-field
                  type="tel"
                  v-model="tecnico.titulo_eleitor_numero"
                  label="Título de eleitor"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <validation-provider
                name="seção do título de eleitor"
                rules="required|max:16"
                v-slot="{ errors }"
              >
                <v-text-field
                  v-model="tecnico.titulo_eleitor_secao"
                  label="Seção do título de eleitor"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <validation-provider
                name="zona do título de eleitor"
                rules="required|max:16"
                v-slot="{ errors }"
              >
                <v-text-field
                  v-model="tecnico.titulo_eleitor_zona"
                  label="Zona do título de eleitor"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <validation-provider
                name="pis/pasep"
                rules="required|max:14"
                v-slot="{ errors }"
              >
                <v-text-field
                  type="tel"
                  v-model="tecnico.pis_pasep"
                  v-mask="`###.#####.##.#`"
                  label="PIS/PASEP"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <AppFormHeader
                title="Informações da formação"
                icon="school"
              />
              <validation-provider
                name="descrição da formação"
                rules="required|max:255"
                v-slot="{ errors }"
              >
                <v-text-field
                  v-model="tecnico.formacao_descricao"
                  label="Descrição"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <validation-provider
                name="data de conclusão da formação"
                rules="required"
                v-slot="{ errors }"
              >
                <v-text-field
                  type="date"
                  v-model="tecnico.formacao_data_conclusão"
                  label="Data de conclusão"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <validation-provider
                name="registro no conselho profissional"
                rules="required|max:45"
                v-slot="{ errors }"
              >
                <v-text-field
                  v-model="tecnico.registro_conselho_profissional"
                  label="Registro no conselho profissional"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <AppFormHeader
                title="Informações de filiação"
                icon="family_restroom"
              />
              <validation-provider
                name="nome da mãe"
                rules="required|max:125"
                v-slot="{ errors }"
              >
                <v-text-field
                  v-model="tecnico.filiacao_mae"
                  label="Nome da mãe"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <validation-provider
                name="nome do pai"
                rules="required|max:125"
                v-slot="{ errors }"
              >
                <v-text-field
                  v-model="tecnico.filiacao_pai"
                  label="Nome do pai"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <AppFormHeader
                title="Informações internas da Coopermais"
                icon="vpn_lock"
              />
              <validation-provider
                name="data de admissão"
                rules="required"
                v-slot="{ errors }"
              >
                <v-text-field
                  type="date"
                  v-model="tecnico.data_admissao"
                  label="Data de admissão"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <validation-provider
                name="número da matrícula"
                rules="required|max:125"
                v-slot="{ errors }"
              >
                <v-text-field
                  v-model="tecnico.numero_matricula"
                  label="Número da matrícula"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <validation-provider
                name="modelo do veículo"
                rules="required|max:125"
                v-slot="{ errors }"
              >
                <v-text-field
                  v-model="tecnico.veiculo_modelo"
                  label="Modelo do veículo"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <validation-provider
                name="placa do veículo"
                rules="required|alpha_num|max:7"
                v-slot="{ errors }"
              >
                <v-text-field
                  type="text"
                  v-model="tecnico.veiculo_placa"
                  label="Placa do veículo"
                  v-mask="mascaraDePlaca"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <!-- <v-subheader
                class="font-weight-bold accent--text"
                v-text="`Identificador para mensagens`"
              />
              <validation-provider
                name="nome de usuário no telegram"
                rules="max:45"
                v-slot="{ errors }"
              >
                <v-text-field
                  prefix="@"
                  v-model="tecnico.telegram_id"
                  label="Nome de usuário no telegram"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider> -->
            </div>
            <div slot="widget-actions">
              <v-spacer />
              <app-button
                v-if="tecnico.id"
                @click.native="remove"
                color="error"
                class="mr-2"
              >
                remover
              </app-button>
              <app-button
                @click.native.prevent="save()"
                :disable="invalid"
              >
                salvar
              </app-button>
            </div>
          </app-widget>
        </v-form>
      </validation-observer>
    </v-flex>
    <v-flex
      v-if="!!tecnico.id"
      sm6
      xs12
    >
      <app-lista-telefone />
    </v-flex>
  </app-logged>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { placa } from '@/plugins/mask'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import AppLogged from '@/components/layouts/AppLogged'
import AppWidget from '@/components/AppWidget'
import AppListaTelefone from '@/components/AppListaTelefone'
import AppFormHeader from '@/components/AppFormHeader'
import AppButton from '@/components/AppButton'
export default {
  name: 'TecnicosCreate',
  components: {
    AppWidget,
    AppLogged,
    ValidationProvider,
    ValidationObserver,
    AppListaTelefone,
    AppFormHeader,
    AppButton
  },
  computed: {
    ...mapGetters(['usuarios', 'cidades', 'tecnico']),
    mascaraDePlaca () {
      return placa
    }
  },
  methods: {
    ...mapActions(['postSaveTecnico', 'deleteTecnico']),
    cidade: item => `${item.nome}/${item.acronimo}`,
    goToTecnicoIndex () {
      this.$router.push({
        name: 'tecnicos-index'
      })
    },
    remove () {
      if (confirm('Confirme a exclusão deste técnico.')) {
        this.deleteTecnico().then(res => {
          this.goToTecnicoIndex()
        })
      }
    },
    save () {
      this.$refs.observer.validate().then(result => {
        if (result) {
          this.postSaveTecnico().then(res => {
            this.goToTecnicoIndex()
          })
        }
      })
    }
  },
  mounted () {}
}
</script>
